module.exports = [{
      plugin: require('../node_modules/gatsby-source-prismic-graphql/gatsby-browser.js'),
      options: {"plugins":[],"repositoryName":"eyib","defaultLang":"en-us","path":"/preview","previews":true,"pages":[{"type":"Tool","match":"/tools/:uid","path":"/tool-preview","component":"/opt/build/repo/src/templates/tool.js"},{"type":"Post","match":"/timeline/:uid","path":"/post-preview","component":"/opt/build/repo/src/templates/post.js"},{"type":"Topic","match":"/topics/:uid","path":"/topic-preview","component":"/opt/build/repo/src/templates/topic.js"}]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
